module.exports = __webpack_public_path__ + "static/media/bad-titanic.f0a59e81.mp3";